import React from 'react';
import { connect } from 'react-redux';
import { Drawer, Table } from 'tdesign-react';
import { getPageConfig } from '@/hooks/useTable';

function RulesTable({ visible, handleClose, rules }) {
  const columns = [
    {
      colKey: 'metricsMode',
      title: '检查模块',
      width: 100,
    },
    {
      colKey: 'metricsName',
      title: '检查项',
      width: 120,
    },
    {
      colKey: 'metricsDescription',
      title: '检查描述',
      width: 180,
    },
    {
      colKey: 'metricsRules',
      title: '检查规则',
      width: 200,
    },
  ];

  return (
    <Drawer
      header='健康度配置'
      size={1000}
      footer={null}
      onClose={handleClose}
      onOverlayClick={handleClose}
      placement='right'
      visible={visible}
    >
      <Table
        maxHeight={'100vh'}
        columns={columns}
        data={rules}
        resizable
        rowKey='metricsName'
        pagination={getPageConfig(rules)}
      />
    </Drawer>
  );
}

export default connect((state) => ({
  rules: state.cluster.rules,
}))(RulesTable);
